import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import {useEffect} from 'react';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './commercialPestControl.css';

const CommercialPestControl = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Commercial Pest Control" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Commercial Pest Control
                </p>
            </PageHeader>
            <section className='services'>

                <div className="commercial-pest-control">
                    <div className="container commercial-pest-control-contcontent-container">
                        <div className="commercial-pest-control-content">
                            <h1>
                                Commercial Pest Control Services
                            </h1>
                            <br />
                            <p>
                                Welcome to PestEX Masters, your premier pest control solution in Kenya. With our unmatched expertise
                                and cutting-edge techniques, we are dedicated to providing top-notch commercial pest control services
                                to businesses across the region. Whether you operate a small office, a bustling restaurant, or a large
                                industrial facility, we have the knowledge and resources to tackle any pest infestation, ensuring a clean
                                and hygienic environment for your employees and customers.
                            </p>

                            <h2>Why Choose PestEX Masters for Commercial Pest Control?</h2>
                            <br/>
                            <ol>
                                <li>
                                    <p>
                                        <b>Tailored Solutions:</b>At PestEX Masters, we understand that every business is unique, and so are
                                        its pest control needs. Our team of experienced professionals takes the time to assess your
                                        specific requirements, identifying potential risks and developing customized pest management
                                        plans. From thorough inspections to targeted treatments, we employ a proactive approach to
                                        effectively eliminate pests and prevent their recurrence.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Comprehensive Services:</b> We offer a wide range of commercial pest control services to address
                                        various pest issues. Whether you&#39;re dealing with rodents, ants, cockroaches, termites, flies, or
                                        any other unwanted guests, our experts are equipped with the knowledge and tools to
                                        eradicate them swiftly and efficiently. We use eco-friendly and safe products, ensuring minimal
                                        disruption to your business operations.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Industry Expertise:</b>With years of experience in the pest control industry, PestEX Masters has
                                        become a trusted name for businesses in Kenya. Our team of licensed technicians stays up to
                                        date with the latest trends and advancements in pest control, allowing us to deliver effective
                                        solutions tailored to your industry. From hospitality to healthcare, retail to manufacturing, we
                                        have the expertise to handle pest challenges in diverse commercial settings.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Proactive Pest Management:</b>We believe in proactive pest management rather than reactive
                                        treatments. Our proactive approach involves regular inspections, monitoring, and preventive
                                        measures to identify and address pest issues before they escalate. By implementing preventive
                                        strategies, we help businesses avoid costly infestations, maintain compliance with health and
                                        safety regulations, and safeguard their reputation.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Excellent Customer Service:</b>At PestEX Masters, we prioritize customer satisfaction. Our friendly
                                        and knowledgeable staff are always ready to assist you, answering your queries, and providing
                                        guidance throughout the pest control process. We value open communication and strive to
                                        build long-term relationships with our clients based on trust, reliability, and exceptional service.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Competitive Pricing:</b>We understand the importance of cost-effectiveness for businesses. PestEX
                                        Masters offers competitive pricing packages without compromising on the quality of our
                                        services. We provide transparent quotes, ensuring there are no hidden costs or surprises along
                                        the way. Rest assured, we deliver the best value for your investment in commercial pest control.
                                    </p>
                                </li>
                            </ol>
                            <br/>
                            <h3>
                                Take Control of Your Commercial Pest Problems Today!
                            </h3>
                            <p>
                                Don&#39;t let pests compromise the success of your business. Trust PestEX Masters for reliable and efficient
                                commercial pest control solutions. Contact us today to schedule a consultation or request a free quote.
                                Our team is ready to assist you in creating a pest-free environment that promotes productivity, health,
                                and peace of mind. Partner with PestEX Masters and experience the difference in pest control
                                excellence.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container commercial-pest-control-saftey-cont">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default CommercialPestControl